import { createAction } from '@reduxjs/toolkit';

import { StorefrontMarketsView, VendorMarketView } from '~/types/responseTypes';

const UPDATED_STOREFRONT_HOME_MARKETS = 'zola/markets/UPDATED_STOREFRONT_HOME_MARKETS';
const UPDATED_STOREFRONT_MARKETS = 'zola/markets/UPDATED_STOREFRONT_MARKETS';

export const updatedMarkets = createAction<VendorMarketView[]>(UPDATED_STOREFRONT_HOME_MARKETS);
export const updatedMarketsV2 = createAction<StorefrontMarketsView>(UPDATED_STOREFRONT_MARKETS);
